exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cookie-consent[data-v-5886d635]{\n  font-family: Calibri, sans-serif !important;\n}\n.cookie-consent p[data-v-5886d635] {\n  font-size: 14px !important;\n}\n.cookie-consent .content[data-v-5886d635] {\n  font-size: 14px !important;\n}\n.show_details[data-v-5886d635] {\n  font-size: 14px;\n  font-weight: normal;\n  cursor: pointer;\n}\n", ""]);

// exports
